import OutlineExclamationIcon from 'components/Icons/OutlineExclamationIcon'
import React, { useEffect, useState } from 'react'
import { IoCloseSharp } from 'react-icons/io5'

interface FixedTopNotificationProps {
    fixedTopPixle?: string
    handleClose: () => void
    show: boolean
    children: JSX.Element
}
export default function FixedTopNotification({
    fixedTopPixle,
    handleClose,
    show,
    children
}: FixedTopNotificationProps) {
    const [topPosition, setTopPosition] = useState(fixedTopPixle ?? '88px')
    useEffect(() => {
        const handleScroll = () => {
            const scrolled = window.scrollY
            const newPosition = scrolled <= 88 ? 88 - scrolled : 0
            setTopPosition(`${newPosition}px`)
        }

        window.addEventListener('scroll', handleScroll)

        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])
    if (!show) {
      return null
    }
    return (
        <div
            style={{
                top: topPosition
            }}
            className={`fixed left-1/2 -translate-x-1/2 transform bg-[#E2E2E2] py-2 px-[25px] lg:w-[1120px] flex items-center justify-between rounded-[4px]`}
      >
        {
          children
        }
            <IoCloseSharp
                data-testid="test-close-icon"
                onClick={handleClose}
                className="text-blueTheme h-6 w-6 p-1 cursor-pointer"
            />
        </div>
    )
}
